class EmailValidator {
  constructor(blockedDomainsString) {
    this.blockedDomains = this.parseBlockedDomains(blockedDomainsString);
    this.validationMessage = 'Please use your business email address.';
  }

  parseBlockedDomains(domainsString) {
    if (!domainsString) return [];

    return domainsString
      .split(',')
      .map(domain => domain.trim().toLowerCase())
      .filter(domain => domain.length > 0);
  }

  isFreemailDomain(email) {
    const domain = email.split('@')[1]?.toLowerCase();
    return this.blockedDomains.includes(domain);
  }

  validateEmailOnSubmit(emailInput) {
    const email = emailInput.value.trim();

    emailInput.setCustomValidity('');

    if (!email) return true;

    const isBlocked = this.isFreemailDomain(email);

    if (isBlocked) {
      emailInput.setCustomValidity(this.validationMessage);
      return false;
    }

    return true;
  }

  initializeForm(formSelectorOrElement) {
    const form = typeof formSelectorOrElement === 'string'
      ? document.querySelector(formSelectorOrElement)
      : formSelectorOrElement;

    if (!form) return;

    const emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;

    form.addEventListener('submit', (e) => {
      this.validateAndPreventSubmit(form, e);
    }, true);

    // Clear custom validation when user starts typing
    emailInput.addEventListener('input', () => {
      emailInput.setCustomValidity('');
    });
  }

  validateAndPreventSubmit(form, event) {
    const emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return true; // No email input, allow submission

    const isValid = this.validateEmailOnSubmit(emailInput);

    if (!isValid) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      form.reportValidity();

      emailInput.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      return false;
    }

    return true;
  }

  initializeAllForms() {
    // Predefined selectors
    const commonFormSelectors = [
      '#NewsletterForm',
      '#ContactForm',
      '#DownloadForm',
      '#WebinarRegisterForm'
    ];

    // Auto-detect forms with email inputs
    const allEmailInputs = document.querySelectorAll('input[type="email"]');

    allEmailInputs.forEach(emailInput => {
      const form = emailInput.closest('form');
      if (form && !form.dataset.emailValidationInitialized) {
        this.initializeForm(form);
        form.dataset.emailValidationInitialized = 'true';
      }
    });

    // Also initialize predefined selectors
    commonFormSelectors.forEach(selector => {
      this.initializeForm(selector);
    });
  }
}

// Global function to be called from theme.liquid
function initEmailValidation(blockedDomainsString) {
  document.addEventListener('DOMContentLoaded', function() {
    const validator = new EmailValidator(blockedDomainsString);
    window.EmailValidator = EmailValidator;
    window.globalEmailValidator = validator;
    validator.initializeAllForms();
  });
}
